import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../../../../../hooks/useStores";
import { ColorTypeMappingEnum } from "../../../../../../../../models/common";
import { Property } from "../../../../../../../CustomUtils/UseDesignEditor";
import UseBrandConfigs from "../../../../../../../hooks/useBrandConfigs";
import styles from "./SelectedBrandColors.module.scss";

interface Iprops {
	updateColor: (color: string) => void;
	activeObject: any;
	property: Property;
}
const SelectedBrandColors = ({ updateColor, activeObject, property }: Iprops) => {
	const { t: tEditorTabs } = useTranslation("translation", { keyPrefix: "editor.tabs" });
	const { brandsDefinitionStore, designEditorStore, campaignStore } = useAppStore();
	const { modifyActiveObjectProperty, handleUpdateActiveObject } = UseBrandConfigs();
	const handleChange = (property: keyof typeof designEditorStore.activeObjectSettings, newValue: any) => {
		modifyActiveObjectProperty(activeObject, property, newValue);
	};

	const selectedBrandColors = brandsDefinitionStore.globalSelectedBrand?.color_pallete?.colors;
	useEffect(() => {
		if (activeObject) {
			handleUpdateActiveObject(activeObject);
		}
	}, [activeObject]);
	if (!campaignStore.selectedTemplate?.is_branded_template) {
		return null;
	}
	return (
		<Box className={styles.selectedBrandColors}>
			<Typography className={styles.mainLabel}>{tEditorTabs("brandColors")}</Typography>
			{selectedBrandColors?.map((color, index) => {
				const currentColorKey = `COLOR_${index + 1}` as keyof typeof ColorTypeMappingEnum;
				return color ? (
					<Box
						onClick={() => {
							handleChange(property, index + 1);
							updateColor(color);
						}}
						key={currentColorKey}
						className={clsx({
							[styles.brandItemContent]: true,
							[styles.activeSelection]:
								(property === Property.COLOR_NUMBER &&
									designEditorStore?.activeObjectSettings.colorNumber === index + 1) ||
								(property === Property.STOKE_COLOR_NUMBER &&
									designEditorStore?.activeObjectSettings?.strokeColorNumber === index + 1) ||
								(property === Property.SHADOW_COLOR_NUMBER &&
									designEditorStore?.activeObjectSettings?.shadowColorNumber === index + 1),
						})}
					>
						<Box sx={{ background: color }} className={styles.itemPreview} />
						<Typography className={styles.itemLabel}>{ColorTypeMappingEnum[currentColorKey]}</Typography>
					</Box>
				) : null;
			})}
		</Box>
	);
};

const ObservedComponent = observer(SelectedBrandColors);
export default ObservedComponent;
